export namespace NTags {
  export type Tag = {
    Id: number;
    Name: string;
    Color: string;
    IconId: string;
    Description: string | null;
    IsDeleted: boolean;
    IsSelected: boolean;
    IsSystem: boolean;
    SystemId?: string | null;
  };

  export type ClientTag = {
    Id: number;
    Name: string;
    Color: string;
    IconId: string;
    Description: string | null;
    IsDeleted: boolean;
    IsSelected: boolean;
    IsSystem: boolean;
    SystemId: string | null;
  };

  export type ModelTag = {
    Id: number;
    Name: string | null;
    Color: string | null;
    IconId: string | null;
    Description: string | null;
    IsDeleted: boolean;
    IsSelected: boolean;
    IsSystem: boolean;
    SystemId: string | null;
  };

  export type ModelClientsTags = {
    ClientIds: number[] | null;
    TagIds: number[] | null;
  };

  export type TagDto = {
    Id: number;
    Name: string | null;
    Color: string | null;
    IconId: string | null;
  };
}
